export default "__VITE_ASSET__BReSB38b__"